/**
 * src/three/audioContext.js
 * AudioContext ตัวเดียวทั้งเกม — iOS เล่นสองตัวพร้อมกันมักเงียบ
 */
let ctx = null;
let resuming = null;

export function getAudioContext() {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx || ctx.state === 'closed') ctx = new AC();
  return ctx;
}

export function resumeAudioContext() {
  const c = getAudioContext();
  if (!c) return Promise.resolve(null);
  if (c.state === 'running') return Promise.resolve(c);
  if (!resuming) {
    resuming = Promise.resolve(c.resume())
      .catch(() => {})
      .then(() => {
        resuming = null;
        return c;
      });
  }
  return resuming;
}

export function decodeAudioData(ctx, data) {
  const copy = data.slice(0);
  try {
    const p = ctx.decodeAudioData(copy);
    if (p && typeof p.then === 'function') return p;
  } catch {
    /* Safari เก่าใช้ callback */
  }
  return new Promise((resolve, reject) => {
    try {
      ctx.decodeAudioData(data.slice(0), resolve, reject);
    } catch (err) {
      reject(err);
    }
  });
}
